import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { RoleResponse } from 'projects/shared/services/roles/models/role.response';
import { InviteBulkUsersResponse, InviteUsersRequest } from 'projects/shared/services/inspection-companies/inspection-company.user.service';
import { UserWithRolesResponse } from 'projects/shared/services/inspection-companies/models/users/user-with-roles.response';

import { InviteUsersModalComponent } from '../invite/invite-users-modal.component';
import { Permission } from 'projects/shared/directives/if-permission.directive';

@Component({
  selector: 'shared-invite-users-button',
  standalone: false,
  template: `<mac-button *ifPermission="invitePermission" (click)="openInviteUsersModal()" icon="add">
      {{ 'Portal.InspectionCompanies.Users.All.InviteUsersButton.Label' | translate }}
    </mac-button>

    <shared-invite-users-modal
      #inviteUsersModal
      [roles$]="roles$"
      [(isVisible)]="isVisible"
      [inviteUsersAction]="inviteUsersAction"
      [bulkInviteUsersAction]="bulkInviteUsersAction"
      (userInvited)="onUserInvited()" />`,
})
export class InviteUsersButtonComponent {
  /**
   * List of roles the user can select when inviting users.
   */
  @Input({ required: true }) roles$: Observable<RoleResponse[]>;

  /**
   * Function to call when inviting users.
   */
  @Input() inviteUsersAction: (model: InviteUsersRequest[]) => Observable<UserWithRolesResponse[]>;

  /**
   * Function to call when bulk inviting users.
   */
  @Input() bulkInviteUsersAction: (file: File) => Observable<InviteBulkUsersResponse>;

  /**
   * Flag to control the visibility of the invite users modal.
   */
  @Input() isVisible? = false;

  /**
   * Event emitted when a user is successfully invited.
   */
  @Output() userInvited = new EventEmitter<void>();

  /**
   * Event emitted when the visibility of the invite users modal changes.
   */
  @Output() isVisibleChange = new EventEmitter<boolean>();

  @ViewChild(InviteUsersModalComponent) inviteUsersModal: InviteUsersModalComponent;

  readonly invitePermission = Permission.InviteUsersToInspectionCompany;

  openInviteUsersModal(): void {
    this.inviteUsersModal.openModal();
  }

  onUserInvited() {
    this.inviteUsersModal.closeModal();
    this.userInvited.emit();
  }
}
